import { Button, Descriptions, Typography } from 'antd';

const { Title } = Typography;

interface ProfileHeaderProps {
  title: string;
  onEdit?: () => void;
  disabled: boolean;
}

export const ProfileHeader: React.FC<ProfileHeaderProps> = ({ title, onEdit, disabled }) => {
  console.log(disabled);

  return (
    <div className="flex justify-between w-full pr-10">
      <Descriptions
        title={<Title level={5}>{title}</Title>}
        extra={
          <Button
            type="primary"
            style={{
              background: disabled ? '#9ea0b4' : '#3F4373',
              color: '#D9D9D9',
              padding: '4px, 15px, 4px, 15px',
              gap: '8px'
            }}
            onClick={onEdit}
            disabled={disabled}
          >
            Edit
          </Button>
        }
      ></Descriptions>
    </div>
  );
};
